import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "docs-demo-mode-toggle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass({ selected: _ctx.lang === 'en-US' }),
      title: "English",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateLang('en-US')))
    }, "EN", 2),
    _createElementVNode("button", {
      class: _normalizeClass({ selected: _ctx.lang === 'de-DE' }),
      title: "German",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateLang('de-DE')))
    }, "DE", 2)
  ]))
}